import { Block, Flex, Icon, Tooltip, Typography } from '@aloft/toolkit-sui';

import { Th, Tr } from '../table.js';

export function HeaderRow({
  includePairedSales,
  includeMatchCriteria,
  includeSubjectInfo,
}: {
  includePairedSales?: boolean;
  includeMatchCriteria?: boolean;
  includeSubjectInfo?: boolean;
}) {
  return (
    <Tr>
      <Th typographyProps={{ color: 'textOffset' }}>Feature</Th>
      {includeMatchCriteria && (
        <Th typographyProps={{ color: 'textOffset' }}>
          <Typography
            variant="tableH1"
            color="textOffset"
            __dangerDoNotUseSx={{ textTransform: 'initial' }}
          >
            Criteria
          </Typography>
        </Th>
      )}
      <Th typographyProps={{ color: 'textOffset' }} colSpan={2}>
        <Flex gap="1rem" alignItems="center">
          <Typography
            variant="tableH1"
            color="textOffset"
            __dangerDoNotUseSx={{ textTransform: 'initial' }}
          >
            Filters
          </Typography>
          {includePairedSales && (
            <Tooltip
              width="17rem"
              padding="0.75rem"
              label={
                <Flex flexDirection="column" gap="1rem">
                  <Block textAlign="center">
                    Use these filters to define the data set you would like to search for pairs.
                  </Block>
                  <Block textAlign="center">Ex. Sold between 11/20/2022 - 11/20/2023</Block>
                </Flex>
              }
            >
              <Flex cursor="pointer">
                <Icon icon="question" color="textOffset" />
              </Flex>
            </Tooltip>
          )}
        </Flex>
      </Th>
      {includePairedSales && (
        <Th typographyProps={{ color: 'textOffset' }} colSpan={2}>
          <Flex gap="1rem" alignItems="center">
            <Typography
              variant="tableH1"
              color="textOffset"
              __dangerDoNotUseSx={{ textTransform: 'initial' }}
            >
              Pair Criteria
            </Typography>
            <Tooltip
              width="17rem"
              padding="0.75rem"
              label={
                <Flex flexDirection="column" gap="1rem">
                  <Block textAlign="center">
                    Use pair criteria to define how the sales in the pair must be similar to each
                    other.
                  </Block>
                  <Block textAlign="center">
                    Ex. The sales in the pair must have a GLA within +/- 25 percent of each other.
                  </Block>
                </Flex>
              }
            >
              <Flex cursor="pointer">
                <Icon icon="question" color="textOffset" />
              </Flex>
            </Tooltip>
          </Flex>
        </Th>
      )}
      {includeSubjectInfo && (
        <Th typographyProps={{ color: 'textOffset' }}>
          <Typography
            variant="tableH1"
            color="textOffset"
            __dangerDoNotUseSx={{ textTransform: 'initial' }}
          >
            Subject Info
          </Typography>
        </Th>
      )}
    </Tr>
  );
}
